const CONSENT_KEY = "rz_cookie_consent";
const TRACKED_KEY = "rz_ads_tracked_orders";
const MAX_ORDER_AGE_MS = 24 * 60 * 60 * 1000;
export const CONSENT_EVENT = "rz-open-cookie-settings";

const gtag = (...args) => {
  if (typeof window.gtag === "function") window.gtag(...args);
};

export const getConsent = () => localStorage.getItem(CONSENT_KEY);

export const setConsent = (granted) => {
  const v = granted ? "granted" : "denied";
  localStorage.setItem(CONSENT_KEY, v);
  gtag("consent", "update", { ad_storage: v, ad_user_data: v, ad_personalization: v });
};

export const openCookieSettings = () => window.dispatchEvent(new Event(CONSENT_EVENT));

const readTracked = () => {
  try { return JSON.parse(localStorage.getItem(TRACKED_KEY)) || []; } catch { return []; }
};

// A purchase counts only for: cash order accepted, or card order confirmed paid. Fires once per order.
export const isConfirmedPurchase = (order) => {
  if (!order || order.order_status === "cancelled") return false;
  if (order.payment_method === "card") return order.payment_status === "paid";
  return order.payment_method === "cash";
};

export const trackPurchase = (order) => {
  const sendTo = process.env.REACT_APP_GADS_SEND_TO;
  if (!sendTo || !isConfirmedPurchase(order)) return false;
  if (order.created_at && Date.now() - new Date(order.created_at).getTime() > MAX_ORDER_AGE_MS) return false;
  const transactionId = String(order.id).replace(/^#/, "");
  const tracked = readTracked();
  if (tracked.includes(transactionId)) return false;
  gtag("event", "conversion", {
    send_to: sendTo,
    value: Math.round(Number(order.total_amount) * 100) / 100,
    currency: "EUR",
    transaction_id: transactionId,
  });
  localStorage.setItem(TRACKED_KEY, JSON.stringify([...tracked, transactionId].slice(-50)));
  return true;
};
